/*
 * File: /src/router/routes/leadTypes.js
 * Created Date: Saturday December 28th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 28th December 2019 3:06:47 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
const ListTypes = () =>
  import(/* webpackChunkName: "ValidDomain" */ 'src/components/Dashboard/Views/LeadTypes/LeadTypeList.vue');

const EditType = () =>
  import(/* webpackChunkName: "ValidDomain" */ 'src/components/Dashboard/Views/LeadTypes/LeadTypeEdit.vue');

export const leadTypeRoutes = [
  {
    path: 'lead-types/',
    name: 'Lead Types',
    component: ListTypes
  },
  {
    path: 'lead-types/add',
    name: 'Add New Lead Type',
    component: EditType
  },
  {
    path: 'lead-types/edit/:id',
    name: 'Edit Lead Type',
    component: EditType,
    props: route => ({ leadTypeId: parseInt(route.params.id)}),
  }
];

